/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Address_NumberInputs */

const en_clients_field_address_number = /** @type {(inputs: Clients_Field_Address_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number`)
};

const pt_br2_clients_field_address_number = /** @type {(inputs: Clients_Field_Address_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número`)
};

/**
* | output |
* | --- |
* | "Number" |
*
* @param {Clients_Field_Address_NumberInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_address_number = /** @type {((inputs?: Clients_Field_Address_NumberInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Address_NumberInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_address_number(inputs)
	return pt_br2_clients_field_address_number(inputs)
});